import PlanExpired from './PlanExpired'
import PlanDetails from './PlanDetails'
import useGetPlanDetails from '../../../../hooks/useGetPlanDetails'
import {
  showExtendPlan,
  viemaxImgUrls,
} from '../../../../constants/viemax-constants'
import BottomSectionWithContact from '../../Components/BottomSectionWithContact'
import { useNavigate } from 'react-router-dom'
import { isInApp, getToken } from '../../../../utils/helpers/common'
import postMessageToRN, {
  NAVIGATE_TO_PAGE_BY_URL,
} from '../../../../utils/helpers/ReactNativeEvents'
import constants from '../../../../constants'

const ViemaxProgramHome = () => {
  const { currentProgress, totalDays, remainingDays, isPlanExpired } =
    useGetPlanDetails()

  const navigate = useNavigate()

  const navigateToExtendPlan = async () => {
    const token = await getToken()
    const url = '/care-plans/viemax-program/extend-plan'
    const appUrl = `${window.location.origin}${url}?support_program_type=${constants.CARE_PROGRAM_TYPE.VIEMAX}&source=mytatva&platform=app&auth_token=${token}`
    if (isInApp()) {
      postMessageToRN(NAVIGATE_TO_PAGE_BY_URL, {
        url: appUrl,
        pageTitle: 'Extend your plan',
      })
      return
    }
    navigate(url)
  }

  return (
    <section className="min-h-screen bg-white pb-4">
      {/* Header Section */}
      <section className="bg-[#F6EDFF]">
        <div className="px-5 pt-6 pb-2">
          <img
            src={viemaxImgUrls.logo}
            alt="Viemax Logo"
            className="w-24 h-7"
          />
        </div>
      </section>

      {showExtendPlan && isPlanExpired ? (
        <PlanExpired
          viemaxImgUrls={viemaxImgUrls}
          onExtendPlan={navigateToExtendPlan}
        />
      ) : (
        <PlanDetails
          currentProgress={currentProgress}
          totalDays={totalDays}
          remainingDays={remainingDays}
          viemaxImgUrls={viemaxImgUrls}
          onExtendPlan={navigateToExtendPlan}
          showExtendPlan={showExtendPlan}
        />
      )}

      {/* your service section */}
      <div className="bg-white px-5 py-6">
        <BottomSectionWithContact />
      </div>
    </section>
  )
}

export default ViemaxProgramHome
